import axios from 'axios';

import { Constants } from '@/constants';

// Default icons are from Themify - supports component icons and SVG icons. See sidebar.components.js for more information.
export const MENUITEMS = [
  {
    title: 'Ad Network',
    permissionKey: 'ad_network',
    type: 'title',
    active: false,
    children: [
      {
        path: 'https://boxpressd.adsrv.org',
        title: 'Dashboard',
        // icon: 'TfiPanel',
        active: false,
        type: 'link',
      },
      {
        path: '#',
        title: 'Settle Payments',
        // iconType: 'component',
        // icon: 'FiCreditCard',
        type: 'action',
        onClick: () => {
          // axios.post(`${Constants.apiPath}/actions/ads/settlements/payouts`).then((response) => {
          //   console.log(response);
          // }).catch((err) => console.error(err));
        },
      },
      {
        path: '#',
        title: 'Settle Payouts',
        // iconType: 'component',
        // icon: 'FiDollarSign',
        type: 'action',
        onClick: () => {
          axios
            .post(`${Constants.apiPath}/actions/ads/settlements/payouts`)
            .then((response) => {
              console.log(response);
            })
            .catch((err) => console.error(err));
        },
      },
    ],
  },
  {
    title: 'Blog',
    permissionKey: 'blog',
    type: 'title',
    active: false,
    children: [
      {
        path: 'https://blog.boxpressd.com/wp-admin/edit.php',
        title: 'All Posts',
        // icon: 'TfiLayers',
        active: false,
        type: 'link',
      },
      {
        path: 'https://blog.boxpressd.com/wp-admin/post-new.php',
        title: 'Add Post',
        // icon: 'TfiPencilAlt',
        active: false,
        type: 'link',
      },
    ],
  },
  {
    title: 'Businesses',
    permissionKey: ['businesses', 'BusinessClaimsApproval'],
    type: 'title',
    active: false,
    badgeType: 'danger',
    badgeStyle: 'dot',
    badgeValue: '{{stats.businessClaims}}',
    children: [
      {
        path: '/brands/manager?filter=other_brands',
        title: 'Bloggers, Podcasters, etc',
        type: 'link',
        permissionKey: 'businesses',
      },
      {
        path: '/venues/manager',
        title: 'Venues',
        type: 'link',
        permissionKey: 'businesses',
        badgeType: 'dark',
        badgeValue: '{{stats.totalVenues}}',
      },
      // FIXME Add this path - should be both venues and brands in one table
      {
        path: '/businesses/claims',
        title: 'Claims',
        type: 'link',
        permissionKey: 'BusinessClaimsApproval',
        badgeType: 'danger',
        badgeValue: '{{stats.businessClaims}}',
      },
    ],
  },
  {
    title: 'Cigars',
    permissionKey: 'cigars',
    type: 'title',
    active: true,
    badgeType: 'danger',
    badgeStyle: 'dot',
    badgeValue: '{{stats.matchRequests}}',
    children: [
      {
        path: '/brands/manager?filter=cigar_brands',
        title: 'Brands',
        type: 'link',
        role: 'manage-brands', // FIXME Finish adding roles so these are hidden if the user does not have permission set
        badgeType: 'dark',
        badgeValue: '{{stats.totalBrands}}',
      },
      {
        path: '/cigars/manager',
        title: 'All Cigars',
        type: 'link',
        role: 'manage-cigars',
        badgeType: 'dark',
        badgeValue: '{{stats.totalCigars}}',
      },
      {
        path: '/targets/manager',
        title: 'Image Recognition',
        type: 'link',
        badgeType: 'info',
        badgeValue: 'Beta',
      },
      {
        path: '/cigars/matches',
        title: 'Match Requests',
        type: 'link',
        badgeType: 'danger',
        badgeValue: '{{stats.matchRequests}}',
      },
      {
        path: '/cigars/vitolas/manager',
        title: 'Vitolas',
        type: 'link',
        badgeType: 'dark',
        badgeValue: '{{stats.totalVitolas}}',
      },
    ],
  },
  {
    title: 'Drink Pairings',
    permissionKey: 'drink_pairings',
    type: 'title',
    active: false,
    children: [
      {
        path: '/drink-pairings/manager',
        title: 'Manage',
        type: 'link',
        badgeType: 'dark',
        badgeValue: '{{stats.totalDrinks}}',
      },
    ],
  },
  {
    title: 'Events',
    permissionKey: 'events',
    type: 'title',
    active: false,
    children: [{ path: '/events/manager', title: 'Manage', type: 'link' }],
  },
  {
    title: 'Groups',
    permissionKey: 'groups',
    type: 'title',
    active: false,
    children: [{ path: '/groups/manager', title: 'Manage', type: 'link' }],
  },
  {
    title: 'Shop',
    permissionKey: 'shop',
    type: 'title',
    active: false,
    children: [
      {
        path: '/shop/manager',
        title: 'Products',
        // icon: 'TfiPencilAlt',
        active: false,
        type: 'link',
        badgeType: 'dark',
        badgeValue: '{{stats.totalProducts}}',
      },
      {
        title: 'Carts',
        type: 'sub',
        active: false,
        children: [
          // {
          //   path: '/shop/carts/manager',
          //   title: 'All Carts',
          //   // icon: 'TfiShoppingCart',
          //   active: false,
          //   type: 'link',
          // },
          {
            path: '/shop/carts/abandoned',
            title: 'Abandoned',
            // icon: 'TfiShoppingCart',
            active: false,
            type: 'link',
          },
        ],
      },
      {
        path: '/shop/orders',
        title: 'Orders',
        // icon: 'TfiPackage',
        active: false,
        type: 'link',
      },

      {
        title: 'Configuration',
        // icon: 'TfiSettings',
        type: 'sub',
        active: false,
        children: [
          {
            path: '/shop/config/payment-gateways',
            title: 'Payment Gateways',
            type: 'link',
          },
          { path: '/shop/config/taxes', title: 'Taxes', type: 'link' },
          { path: '/shop/config/shipping', title: 'Shipping', type: 'link' },
        ],
      },
    ],
  },
  {
    title: 'Tools',
    permissionKey: 'tools',
    type: 'title',
    active: false,
    children: [
      {
        title: 'SEO',
        type: 'sub',
        active: false,
        children: [
          {
            path: 'https://search.google.com/search-console/performance/search-analytics?resource_id=sc-domain%3Aboxpressd.app&num_of_days=28',
            title: 'View Performance',
            // icon: 'TfiPanel',
            active: false,
            type: 'link',
          },
          {
            path: '/seo/sitemap',
            title: 'Update Sitemaps',
            // iconType: 'component',
            // icon: 'FiRefreshCw',
            type: 'action',
            onClick: () => {
              const types = [
                'articles',
                'news',
                'brands',
                'cigars',
                'products',
                'venues',
                'groups',
                'events',
                'users',
                'checkin_videos',
                'session_videos',
              ];
              const promises = [];
              // TODO Handle paging - products, for one, have multiple sitemaps
              // FIXME Maybe add success = [] and failure = [] so we can show a popup with the list of sitemaps and whether they updated or not
              types.forEach((type) => {
                promises.push(
                  axios.put(`${Constants.apiPath}/sitemaps/${type}/sitemap.xml`)
                );
              });
              Promise.all(promises)
                .then(() => {
                  alert('Sitemaps updated!');
                })
                .catch((err) => console.error(err)); // TODO Toast instead?
            },
          },
        ],
      },
      {
        path: 'http://status.boxpressd.com',
        title: 'Status',
        // icon: 'TfiAlert',
        active: false,
        type: 'link',
      },
      // {
      //   path: 'https://boxpressd.slack.com/', title: 'Slack', iconType: 'component', icon: 'FiSlack', active: false, type: 'link',
      // },
      {
        // FIXME Would like their logo
        path: 'https://teams.microsoft.com',
        title: 'Teams',
        // iconType: 'component',
        // icon: 'FiUsers',
        active: false,
        type: 'link',
      },
      {
        path: 'https://boxpressd.sharepoint.com',
        title: 'Wiki',
        // icon: 'TfiBook',
        active: false,
        type: 'link',
      },
      {
        // FIXME Would like their logo
        // path: 'https://vault.boxpressd.io:8200', title: 'Vault', iconType: 'svg', icon: 'vault', active: false, type: 'link'
        path: 'https://vault.boxpressd.io:8200',
        title: 'Vault',
        // icon: 'TfiUnlock',
        active: false,
        type: 'link',
      },
      {
        // FIXME Would like their logo
        // path: 'https://app.breezy.hr/app/c/boxpressd/home', title: 'Breezy', iconType: 'svg', icon: 'vault', active: false, type: 'link'
        path: 'https://app.breezy.hr/app/c/boxpressd/home',
        title: 'Breezy',
        // icon: 'TfiBriefcase',
        active: false,
        type: 'link',
      },
      {
        title: 'Analytics',
        // icon: 'TfiBarChart',
        type: 'sub',
        badgeType: 'primary',
        badgeValue: 'new',
        active: false,
        children: [
          {
            path: 'https://insights.hotjar.com',
            title: 'Hotjar',
            type: 'link',
          },
          {
            path: 'https://app.logrocket.com/xbsriq/boxpressd',
            title: 'LogRocket',
            type: 'link',
          },
          {
            path: 'https://app.smartlook.com/org/4db92ce087819b41fe0c2d83/project/06f4bf98cec52633cec9535a/dashboard',
            title: 'Smartlook',
            type: 'link',
          },
          {
            path: 'https://app.livesession.io/app/9c87714b',
            title: 'LiveSession',
            type: 'link',
          },
          {
            path: 'https://app.segment.com/boxpressd/overview',
            title: 'Segment',
            type: 'link',
          },
          {
            path: 'https://analytics.amplitude.com/boxpressd',
            title: 'Amplitude',
            type: 'link',
          },
          {
            path: 'https://boxpressd.grafana.net/',
            title: 'Grafana',
            type: 'link',
          },
          {
            path: 'https://app.pendo.io/s/6621173319073792',
            title: 'Pendo',
            type: 'link',
          },
        ],
      },
      {
        title: 'Growth',
        // icon: 'TfiStatsUp',
        type: 'sub',
        badgeType: 'primary',
        badgeValue: 'new',
        active: false,
        children: [
          {
            path: '/tools/growth',
            title: 'Page Views',
            type: 'link',
          },
          {
            path: 'https://app.onesignal.com/',
            title: 'OneSignal',
            type: 'link',
          },
          {
            path: 'https://app.sendgrid.com/',
            title: 'SendGrid',
            type: 'link',
          },
          {
            path: 'https://console.twilio.com/',
            title: 'Twilio',
            type: 'link',
          },
          { path: 'https://app.apollo.io', title: 'Apollo CRM', type: 'link' },
          {
            path: 'https://ads.boxpressd.com/',
            title: 'Ad Server',
            type: 'link',
          },
        ],
      },
      {
        title: 'Developer',
        // icon: 'TfiHarddrives',
        type: 'sub',
        badgeType: 'primary',
        badgeValue: 'new',
        active: false,
        children: [
          {
            path: 'https://console.aws.amazon.com/console/home?region=us-east-1',
            title: 'AWS',
            type: 'link',
          },
          {
            path: 'https://console.firebase.google.com/',
            title: 'Firebase',
            type: 'link',
          },
          {
            path: 'https://telemetry.betterstack.com/team/89719/tail',
            title: 'Betterstack (Logtail)',
            type: 'link',
          },
          {
            path: 'https://web.postman.co/collections/4886111-0ce89295-6395-4dff-97bb-fa4502efa46f',
            title: 'API Docs',
            type: 'link',
          },
          {
            path: 'https://sentry.io/organizations/boxpressd/',
            title: 'Sentry',
            type: 'link',
          },
          {
            path: 'https://one.newrelic.com',
            title: 'New Relic',
            type: 'link',
          },
          { path: 'https://app.testim.io/', title: 'Testim', type: 'link' },
          {
            path: 'https://portal.sofy.ai/app/applications/testruns?applicationguid=47ecb38d-7d79-0ba7-670e-ac6050647038&applicationid=37636',
            title: 'Sofy.ai',
            type: 'link',
          },
          { path: 'https://poeditor.com', title: 'Translations', type: 'link' },
          {
            path: 'https://appetize.io/app/standalone',
            title: 'Appetize',
            type: 'link',
          },
          {
            path: 'https://railway.com/dashboard',
            title: 'Railway',
            type: 'link',
          },
          {
            path: 'https://vercel.com/boxpressd',
            title: 'Vercel',
            type: 'link',
          },
          {
            path: 'https://supabase.com/dashboard',
            title: 'Supabase',
            type: 'link',
          },
        ],
      },
      {
        title: 'Finances',
        // icon: 'TfiMoney',
        type: 'sub',
        badgeType: 'primary',
        badgeValue: 'new',
        active: false,
        children: [
          {
            path: 'https://billing.boxpressd.com/',
            title: 'Lago Billing',
            type: 'link',
          },
          {
            path: 'https://bluevine.com/',
            title: 'Bluevine Banking',
            type: 'link',
          },
          {
            path: 'https://waveapps.com',
            title: 'Wave Accounting',
            type: 'link',
          },
          { path: 'https://pcivault.io/', title: 'PCI Vault', type: 'link' },
          { path: 'https://www.paypal.com', title: 'PayPal', type: 'link' },
          {
            path: 'https://www.authorize.net/',
            title: 'Authorize.Net',
            type: 'link',
          },
          {
            path: 'https://give.cornerstone.cc/dashboard',
            title: 'Cornerstone Gateway',
            type: 'link',
          },
          {
            path: 'https://pay.cornerstone.cc/boxpressd',
            title: 'Cornerstone Payments',
            type: 'link',
          },
          {
            path: 'https://cps.transactiongateway.com/merchants/index.php?tid=2f5cf1a9280486b2911aa7037d674906',
            title: 'NMI',
            type: 'link',
          },
          {
            path: 'https://my.causal.app',
            title: 'Sales Forecast',
            type: 'link',
          },
        ],
      },
      {
        title: 'User Support',
        // icon: 'TfiHeadphoneAlt',
        type: 'sub',
        badgeType: 'primary',
        badgeValue: 'new',
        active: false,
        children: [
          {
            path: 'https://lounge.boxpressd.com',
            title: 'Virtual Lounge',
            type: 'link',
          },
          {
            path: 'https://helpdesk.boxpressd.com',
            title: 'Freshdesk Help Center',
            type: 'link',
          },
        ],
      },
    ],
  },
  {
    title: 'Users',
    permissionKey: 'users',
    type: 'title',
    active: false,
    badgeType: 'success',
    badgeValue: 'New!',
    children: [
      {
        path: '/users/manager',
        title: 'Manage',
        type: 'link',
        badgeType: 'dark',
        badgeValue: '{{stats.totalUsers}}',
      },
    ],
  },
];
